import { useQuery } from '@tanstack/react-query';
import { INCIDENT_TICKETS } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { fetchIncidentTickets } from '../api';
import type { IncidentTicketRow } from '../types';

type Props = {
  incidentId?: string;
  enabled?: boolean;
};

const useIncidentTickets = ({ incidentId, enabled = true }: Props) => {
  const selectedEnvId = useSelectedEnv();

  return useQuery<IncidentTicketRow[]>({
    queryKey: [INCIDENT_TICKETS, selectedEnvId, incidentId],
    queryFn: () => fetchIncidentTickets(selectedEnvId!, incidentId!),
    enabled: enabled && !!incidentId && !!selectedEnvId,
  });
};

export default useIncidentTickets;
